import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import moment from 'moment';
import en from './resources/en.json';
import ja from './resources/ja.json';
import * as LocalStorageUtil from '../utils/LocalStorageUtil';
var resources = {
    en: {
        translation: en
    },
    ja: {
        translation: ja
    }
};
var storeLanguage = function (language) {
    LocalStorageUtil.storeItem(LocalStorageUtil.LANGUAGE_CODE, language);
    return language;
};
var localLanguage = LocalStorageUtil.getItem(LocalStorageUtil.LANGUAGE_CODE);
var defaultLanguage = localLanguage ? localLanguage : storeLanguage('ja');
moment.locale(defaultLanguage);
i18n
    .use(initReactI18next)
    .init({
    resources: resources,
    lng: defaultLanguage ? defaultLanguage : 'ja',
    interpolation: {
        escapeValue: false // react already safes from xss
    }
});
export default i18n;
